import Layout from "@/views/Layout";

import ManageEducation from "@/views/ManageEducation/ManageEducation";
import QuestionDepository from "@/views/ManageEducation/QuestionDepository";
import AssessmentDepository from "@/views/ManageEducation/AssessmentDepository";
import AssessmentScore from "@/views/ManageEducation/AssessmentScore";
import TeacherSchedule from "@/views/ManageEducation/TeacherSchedule";
import AssessmentDepositoryEdit from "@/views/ManageEducation/AssessmentDepositoryEdit";
import OfflineScore from "@/views/ManageEducation/OfflineScore"
import TeacherClass from "@/views/ManageEducation/TeacherClass";
import ManageCourse from "@/views/ManageEducation/ManageCourse";

import ManageStudy from "@/views/ManageStudy/ManageStudy";
import StudentCertificate from "@/views/ManageStudy/StudentCertificate";
import StudentCourse from "@/views/ManageStudy/StudentCourse";
import StudentSchedule from "@/views/ManageStudy/StudentSchedule";
import StudentRecord from "@/views/ManageStudy/StudentRecord";
import StudentAssessment from "@/views/ManageStudy/StudentAssessment";
import StudentAssessmentScore from "@/views/ManageStudy/StudentAssessmentScore";
import StudentAssessmentAnswer from "@/views/ManageStudy/StudentAssessmentAnswer";
import CourseChapter from "@/views/ManageStudy/CourseChapter";

const manageEducation = {
    "path": "/",
    "name": "layout",
    "component": Layout,
    "children": [
        {
            "path": "/ManageEducation",
            "name": "教学管理",
            "component": ManageEducation,
            "children": [
                {
                    "path": "TeacherSchedule",
                    "name": "教员课表",
                    "component": TeacherSchedule
                },
                {
                    "path": "QuestionDepository",
                    "name": "题库管理",
                    "component": QuestionDepository
                },
                {
                    "path": "AssessmentDepository",
                    "name": "考核管理",
                    "component": AssessmentDepository
                },
                {
                    "path": "AssessmentDepositoryEdit",
                    "name": "考核管理编辑",
                    "component": AssessmentDepositoryEdit
                },
                {
                    "path": "OfflineScore",
                    "name": "线下成绩录入",
                    "component": OfflineScore
                },
                {
                    "path": "AssessmentScore",
                    "name": "学员考核成绩",
                    "component": AssessmentScore
                },
                {
                    "path": "TeacherClass",
                    "name": "我的班级",
                    "component": TeacherClass
                },
                {
                    "path": "ManageCourse",
                    "name": "课程管理",
                    "component": ManageCourse
                }
            ]
        }
    ]
}

const manageStudy = {
    "path": "/",
    "name": "layout",
    "component": Layout,
    "children": [
        {
            "path": "/ManageStudy",
            "name": "学习管理",
            "component": ManageStudy,
            "children": [
                {
                    "path": "StudentCertificate",
                    "name": "学员证书",
                    "component": StudentCertificate
                },
                {
                    "path": "StudentCourse",
                    "name": "学员课程",
                    "component": StudentCourse
                },
                {
                    "path": "/CourseChapter",
                    "name": "学员课程详情",
                    "component": CourseChapter
                },
                {
                    "path": "StudentSchedule",
                    "name": "学员课表",
                    "component": StudentSchedule
                },
                {
                    "path": "StudentRecord",
                    "name": "学习记录",
                    "component": StudentRecord
                },
                {
                    "path": "StudentAssessment",
                    "name": "考核任务",
                    "component": StudentAssessment
                },
                {
                    "path": "StudentAssessmentScore",
                    "name": "考核成绩",
                    "component": StudentAssessmentScore
                },
                {
                    "path": "StudentAssessmentAnswer",
                    "name": "考核答题",
                    "component": StudentAssessmentAnswer
                }
            ]
        }
    ]
}

export {
    manageEducation,
    manageStudy
}
